// @ts-check

/**
 * @typedef{{
 *	name: string,
 *	count: number,
 *  sizeLabel: string | ''
 *	products: ProductItem[]
 * }} RelatedProductCategory
 *
 * @typedef{{
 *	link: string,
 *	price: string,
 *	alt: string,
 *	name: string,
 *	groupName: string,
 *	image: string
 * }} ProductItem
 */

/**
 * @returns {{
 * 	subproductId: number | null,
 * 	init: () => void,
 * 	fetchFilter: () => void
 * 	relatedProductCategories: RelatedProductCategory[],
 * 	tabIndex: number,
 * 	isMobileCollapseOpen: boolean,
 * 	showMoreCounts: number[]
 * }}
 */
export default () => ({
	subproductId: null,
	relatedProductCategories: [],
	tabIndex: 0,
	isMobileCollapseOpen: false,
	showMoreCounts: [],

	init() {
		this.$watch('subproductId', () => this.fetchFilter());
	},

	fetchFilter() {
		fetch(`/api/showers/${this.subproductId}/related-products`)
			.then((resp) => resp.json())
			.then((json) => {
				this.relatedProductCategories = json.data;
				console.info(json.data);
				this.showMoreCounts = Array(
					this.relatedProductCategories.length
				).fill(0);
			});
	},
});
